import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'cap-form-field',
  templateUrl: './form-field.component.html'
})
export class FormFieldComponent {
  @Input() public control: AbstractControl;
  @Input() public label: string;
}
